export const UNLOCK_ADMINISTRATORS_GROUP = 'UNLOCK-Administrators';

const normalizeGroupName = (groupName) => {
    if (typeof groupName !== 'string') {
        return '';
    }

    return groupName.trim().replace(/^\/+/, '').toLowerCase();
};

export const hasUnlockAdministratorAccess = (groups) => {
    if (!Array.isArray(groups)) {
        return false;
    }

    const requiredGroup = UNLOCK_ADMINISTRATORS_GROUP.toLowerCase();
    return groups.some((groupName) => normalizeGroupName(groupName) === requiredGroup);
};
